// Polyfill
import "@node_modules/core-js/stable";
import "@node_modules/regenerator-runtime/runtime";

// Libs
import Vue from 'vue'
import VueI18n from '@node_modules/vue-i18n'
import Vuex from '@node_modules/vuex'
import VueRouter from '@node_modules/vue-router'

import { mapGetters, mapState, mapActions } from '@node_modules/vuex';

// Legacy Libs
import '@base_js/base.js'
import { script } from '@base_js/script'

// Store
import store  from '@store';

// Mixins
import InitMixin from '@mixins/init_mixin';
import LegacyBridgeMixin from '@mixins/legacy_bridge_mixin';

// LESS
import '@less/community.less'

// Assets

// Application components
import TabsCmp from '@components/tabs_cmp'
import InitiativesCmp from '@components/initiatives_cmp'
import TrainingCmp from '@components/training_cmp'
import NetworkCmp from '@components/network_cmp'

import router from '@routes/community'

Vue.use(VueI18n)
Vue.use(Vuex)
Vue.use(VueRouter)

Vue.config.ignoredElements = [
  /^pdb-/,
]

const i18n = new VueI18n({
  locale: "curr",
  messages
})

// Application instance
const vueInstance = new Vue({
  store,
  router,
  i18n,
  mixins: [
  	InitMixin,
    LegacyBridgeMixin
  ],
  el: '#app-root',
  computed: {
    startTab(){
      return !!window.location.hash ? window.location.hash.substr(2) : 'network'
    }
  },
  components: {
    TabsCmp,
    InitiativesCmp,
    TrainingCmp,
    NetworkCmp
  }
})


